module.exports = __webpack_public_path__ + "img/tabbar_like2@3x.eca9fefe.png";